import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import baseUrl from "../../api/baseUrl";
import {RootState} from "../index";
import ProviderCreateRequestDto from "../../dto/ProviderCreateRequestDto";
import ProviderUpdateRequestDto from "../../dto/ProviderUpdateRequestDto";

const providerApi = createApi({
    reducerPath: "provider",
    tagTypes: ['Provider'],
    baseQuery: fetchBaseQuery({
        baseUrl: `${baseUrl}/api/v1/provider`,
        prepareHeaders: (headers, {getState}) => {
            const token = (getState() as RootState).auth.token;

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        createProvider: builder.mutation({
            query: (body: ProviderCreateRequestDto) => {
                return {
                    url: '',
                    method: 'POST',
                    body: body
                }
            },
            invalidatesTags: ['Provider'],
        }),
        updateProvider: builder.mutation({
            query: (body: ProviderUpdateRequestDto) => {
                const {id} = body;
                return {
                    url: `/${id}`,
                    method: 'PUT',
                    body: body
                }
            },
            invalidatesTags: ['Provider'],
        }),
        fetchProvider: builder.query({
            query: (id) => {
                return {
                    url: `/by-id/${id}`,
                    method: 'GET'
                }
            },
            providesTags: ['Provider'],
        })
    })
});

export const {
    useCreateProviderMutation,
    useUpdateProviderMutation,
    useFetchProviderQuery
} = providerApi;
export {providerApi};